<template>
  <div v-if="messageRepied">
    [Danh thiếp] {{ content.title }}
  </div>
  <div v-else class="d-flex flex-column" style="min-width: 230px;min-height: 130px;">

    <div class="fw-semibold align-self-end mb-2" style="color: #7e8c9e">Danh thiếp Zalo</div>
    <div class="d-flex mb-2 ">
      <div class="d-flex flex-column ">
        <el-avatar class="mt-1 " :size="50"  :src="content.thumb" />
        <div class="flex-1"></div>
        <div class="font-size-14 fw-semibold "> {{ content.title }}</div>
        <div class="font-size-14 fw-semibold "> {{ JSON.parse(content.description).phone }}</div>
      </div>
      <div class="flex-1"></div>
      <div  class="align-self-center">
      <el-popover placement="top" width="300" trigger="click">
        <el-image  class="align-self-center" :src="JSON.parse(content.description).qrCodeUrl" style="margin-left: auto;max-width: 300px; max-height: 300px" />
        <el-image slot="reference" class="pointer" :src="JSON.parse(content.description).qrCodeUrl" style="margin-left: auto;max-width: 80px; max-height: 80px" />
      </el-popover>
      </div></div>
    <div style="border-bottom: 1px solid #ececec;margin-right: -20px;margin-left: -20px " ></div>

    <el-popover placement="bottom" width="300" trigger="click">
      <el-input type="textarea" placeholder="Nhập nội dung tin nhắn" :row="2" v-model="messageText"></el-input>
      <div class="d-flex justify-content-end">
        <el-button type="primary" size="mini" class="mt-2" @click="sendMessage()">Gửi</el-button>
      </div>
      <div slot="reference" @click="showPopupMessage=true" style="color: #206de0;padding-top: 12px;"  class="pointer fw-semibold text-center  font-size-14 ">NHẮN TIN</div>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: "ChatBusinessCard",
  props: ["message", "accountId", "messageRepied"],
  data() {
    return {
      showPopupMessage: false,
      messageText: ""
    };
  },
  computed: {
    content() {
      return JSON.parse(this.message.content);
    }
  },
  methods: {

    sendMessage() {
      if (!this.messageText) {
        this.alert("error", "Nhập nội dung cần gửi.");
        return;
      }

      let request = {
        accountId: this.accountId,
        toId: this.content.params,
        message: this.messageText
      };
      this.$http.post("/api/message/sms", request).then(() => {
        this.messageText = "";
        this.showPopupMessage = false;
        this.alert("success", "Đã gửi tin nhắn");
      });

    }
  }
};
</script>

<style scoped>

</style>